import Module from "./Module";
import PemesananApp from "./views/PemesananApp";
import DetailPembayaran from "./views/DetailPembayaran";

const requireAuth = { requireAuth: true };

const moduleRoute = {
  path: "/whitelabel",
  component: Module,
  children: [
    {
      path: "/",
      component: Module,
      children: [
        {
          path: "",
          name: "whitelabel",
          component: PemesananApp,
          meta: {
            ...requireAuth,
          },
        },
        {
          path: "detailPembayaran/:idcicilan",
          name: "WhitelabelDetailPembayaranCicilan",
          component: DetailPembayaran,
          meta: {
            ...requireAuth,
          },
        },
      ],
    },
  ],
};

export default (router) => {
  router.addRoutes([moduleRoute]);
};
